import { matchPath } from 'react-router';

export default function matchRoute(routes, path) {
    let match = null;
    let route = routes.find(route => (match = matchPath(path, route))) || null;

    return { route, match };
}